/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const bulkCreateItemObjectiveRequestSchema = z.object({
  itemIds: z.array(z.int()),
  objectiveId: z.int(),
});
